<template>
  <section class="f-21" ref="root">
    <div class="beauty-3d-video" ref="car3dVideo">
      <div class="beauty-3d-center" ref="car3dCenter">
        <EndTitle class="title" ref="title" />
        <div class="frame" ref="frame">
          <div class="video_frame" ref="videoFrame">
            <m-video
              ref="video"
              class="video f-select-center"
              muted
              disablepictureinpicture
              playsinline
              webkit-playsinline
              poster="@/v2/auto/assets/video/20/poster/0.jpg"
              src="@/v2/auto/assets/video/20/0.mp4"
            />
            <replay @click="replayVideo($refs.video)" />
          </div>
          <img
            class="beauty_3d_kpi"
            ref="kpi"
            src="@/v2/auto/assets/image/20/kpi.svg"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import EndTitle from '@/v2/auto/assets/image/20/end_title.vue'
import { replayVideo, videoPlayByVisibleArea } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
    EndTitle,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const { car3dVideo, root, video, car3dCenter, videoFrame, title, kpi } =
      this.$refs
    videoPlayByVisibleArea(video)
    const activeLabel = 'showKpi'
    const gsap = this.$gsap
    gsap.set(kpi, { x: '-50%', y: '-50%' })
    gsap.set(videoFrame, { x: '-50%', left: '50%' })
    // 标志位，用于记录当前播放状态
    let isPlaying = false
    // 创建滚动动画事件线
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: car3dVideo,
        pin: true,
        scrub: 0.5,
        snap: {
          snapTo: 'labelsDirectional', //
          duration: { min: 0, max: 1.2 },
          delay: 0,
          inertia: false,
        },
        onUpdate: (self) => {
          if (self.direction === -1) {
            video.currentTime = 0
            video.pause()
          }
          if (tl.currentLabel() === activeLabel) {
            this.$gsap.set(root, { zIndex: 81 })
          } else {
            this.$gsap.set(root, { zIndex: 79 })
          }
          // 滑动完成后动态计算根布局高度,避免内容截断
          if (car3dCenter) {
            const rect = car3dCenter.getBoundingClientRect()
            const height = `calc(200vh + ${rect.height}px)`
            this.$gsap.set(root, { height })
          }
        },
        // markers: true
      },
    })
    tl.addLabel('1', { directional: false })
    tl.to(kpi, { opacity: 0 }, '1')
    // // 平移，显示出指标slogan
    tl.addLabel(activeLabel)
    tl.to(title.$el, { opacity: 0 }, activeLabel)
    tl.to(
      videoFrame,
      {
        left: `calc(20% + ${kpi.clientWidth + 100}px)`,
        x: '0%',
        ease: 'power2.in',
      },
      activeLabel,
    )
    tl.to(
      kpi,
      {
        opacity: 1,
        left: '20%',
        x: '-0%',
        y: '-50%',
        ease: 'power2.in',
      },
      activeLabel,
    )
    tl.addLabel('end')
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.f-21 {
  width: 100%;
  background-color: rgb(0, 0, 0);
  position: relative;
  z-index: 79;
  height: 300vh;
  .beauty-3d-video {
    position: sticky;
    top: 0;
    width: 100%;
    height: 200vh;
    min-height: 800px;
    margin-top: -100vh;

    overflow: hidden;
    .beauty-3d-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
    }

    .title {
      height: 20%;
      max-height: 120px;
      min-height: 80px;
      margin: 2.5% 0;
    }
    .frame {
      position: relative;
      color: white;
      width: 100%;
      .beauty_3d_kpi {
        position: absolute;
        height: 80%;
        width: 535px;
        max-width: 30%;
        opacity: 0;
        left: 50%;
        top: 50%;
      }
      .video_frame {
        width: min-content;
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        left: 50%;
        gap: 25px;
      }
      .video {
        border-radius: 24px;
        object-fit: cover;
        display: block;
      }
    }
  }
}
</style>
